import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=1aceac36&"
import script from "./DoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./DoughnutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports